// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3xJq4","messages":"Chat_messages__26JMU","dateDivider":"Chat_dateDivider__2sTl-"};